import { render } from "./scatteredploatwithline.vue?vue&type=template&id=98f48814&scoped=true"
import script from "./scatteredploatwithline.vue?vue&type=script&lang=js"
export * from "./scatteredploatwithline.vue?vue&type=script&lang=js"

import "./scatteredploatwithline.vue?vue&type=style&index=0&id=98f48814&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98f48814"]])

export default __exports__